import React, { useState, useMemo, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function NinetySixHome() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("genz");

  const eightPillars = [
    { label: "SAKSHAM MSME", icon: "🏭", path: "/msme", backColor: "black", stripColor: "indigo", desc: "Support for micro, small, and medium enterprises through digital enablement and growth tools." },
    { label: "SAKSHAM Shakti", icon: "🦋", path: "/sheearns", backColor: "black", stripColor: "violet", desc: "Women-centric empowerment pillar enabling learning, earning, and financial independence via SHGs and individuals." },
    { label: "SAKSHAM Agri", icon: "🌾", path: "/agrilink", backColor: "black", stripColor: "green", desc: "Connecting farmers to markets, intelligence, finance, and modern agricultural resources." },
    { label: "SAKSHAM Shram", icon: "🧢", path: "/sakshamshram", backColor: "black", stripColor: "blue", desc: "Blue-collar workforce empowerment through skilling, jobs, safety, and dignity." },
    { label: "Teachable", icon: "🧑‍🏫", path: "/teachable", backColor: "black", stripColor: "orange", desc: "A platform for educators, trainers, and institutions to create and deliver online courses." },
    { label: "MATRIKA", icon: "👩‍👧", path: "/matrika", backColor: "black", stripColor: "pink", desc: "Maternal and child health ecosystem for care tracking, awareness, and wellbeing." },
    { label: "YUVASolver", icon: "🧑‍💻", path: "/yuvasolver", backColor: "black", stripColor: "cyan", desc: "Youth-driven innovation and problem-solving community for real-world challenges." },
    { label: "SHEETAL Govt", icon: "❄️", path: "/sheetaldashboard", backColor: "black", stripColor: "teal", desc: "Systematic, data-driven transformation of governance efficiency and service delivery." },
  ];

  return (
    <div className="min-h-screen bg-black text-white [&_p]:text-gray-100 p-2 lg:p-4">
      <div className="max-w-7xl mx-auto">

        <div className="mb-4">
          <h1 className="text-lg lg:text-3xl font-bold text-cyan-300 flex items-center gap-2">
            <i className="fa-solid fa-rocket"></i>
            19NinetySix+ Generations Ecosystem
          </h1>

          <p className="text-xs lg:text-sm text-gray-300 mt-2">
            Beyond classrooms. Beyond random internet knowledge. Beyond passive AI usage.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 mb-4">
          <button
            onClick={() => setActiveTab("genz")}
            className={`rounded-xl px-2 py-2 text-xs lg:text-sm font-semibold transition-all
              ${
                activeTab === "genz"
                  ? "bg-cyan-600 text-white"
                  : "bg-slate-800 hover:bg-slate-700 text-gray-300"
              }`}
          >
            ⚡ Gen Z
          </button>

          <button
            onClick={() => setActiveTab("genalpha")}
            className={`rounded-xl px-2 py-2 text-xs lg:text-sm font-semibold transition-all
              ${
                activeTab === "genalpha"
                  ? "bg-cyan-600 text-white"
                  : "bg-slate-800 hover:bg-slate-700 text-gray-300"
              }`}
          >
            🌍 Gen Alpha
          </button>

          <button
            onClick={() => setActiveTab("startup")}
            className={`rounded-xl px-2 py-2 text-xs lg:text-sm font-semibold transition-all
              ${
                activeTab === "startup"
                  ? "bg-cyan-600 text-white"
                  : "bg-slate-800 hover:bg-slate-700 text-gray-300"
              }`}
          >
            🚀 Gen Z Digital Startup
          </button>

        </div>
        {activeTab === "genz" && (
          <div className="space-y-4">

            <div className="rounded-2xl bg-slate-900 border border-cyan-500/20 p-3 lg:p-5 shadow-xl">
              <h2 className="text-sm lg:text-xl font-bold text-cyan-300 flex items-center gap-2">
                <i className="fa-solid fa-bolt"></i>
                What is the Gen Z Era?
              </h2>

              <div className="space-y-3 mt-3">
                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  ⚡ The Gen Z Era is the age of AI-assisted, digitally native, creator-driven, fast-learning, skill-first transformation ecosystems.
                </p>

                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  🌐 Gen Z represents the first true digital-native generation that grew up with smartphones, social media, YouTube, streaming, gaming, creator economies, and AI-powered experiences.
                </p>

                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  🚀 Unlike older generations that adapted to technology later, Gen Z was born directly into the internet-first ecosystem.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">

              <div className="rounded-2xl bg-slate-900 border border-yellow-500/20 p-3 lg:p-5">
                <h3 className="text-sm lg:text-lg font-bold text-yellow-300 flex items-center gap-2">
                  <i className="fa-solid fa-mobile-screen-button"></i>
                  Gen Z Mindset
                </h3>

                <div className="space-y-3 mt-3">
                  <p className="text-xs lg:text-sm text-gray-300">
                    📱 Gen Z prefers short-form, visual, practical, interactive, and outcome-driven learning.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    🎯 They care more about skills, income opportunities, startups, freelancing, creator economies, and practical growth than only traditional degrees.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    🧠 They expect real-time learning, AI assistance, personalized growth, and continuous progression.
                  </p>
                </div>
              </div>

              <div className="rounded-2xl bg-slate-900 border border-emerald-500/20 p-3 lg:p-5">
                <h3 className="text-sm lg:text-lg font-bold text-emerald-300 flex items-center gap-2">
                  <i className="fa-solid fa-users"></i>
                  Gen Z Ecosystem Thinking
                </h3>

                <div className="space-y-3 mt-3">
                  <p className="text-xs lg:text-sm text-gray-300">
                    🤝 Gen Z values communities, collaboration, authenticity, purpose, recognition, and identity.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    ⚡ Gamification, streaks, XP systems, transformation journeys, and ecosystem participation strongly influence engagement.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    🌍 Modern ecosystems now blend AI, creator economies, startups, learning systems, and digital entrepreneurship together.
                  </p>
                </div>
              </div>

            </div>

            <div className="rounded-2xl bg-gradient-to-r from-cyan-900/40 to-blue-900/40 border border-cyan-400/20 p-3 lg:p-5">
              <h3 className="text-sm lg:text-lg font-bold text-cyan-200 flex items-center gap-2">
                <i className="fa-solid fa-brain"></i>
                Why Think5Whys Fits the Gen Z Era
              </h3>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-4">

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🚀 Startup, earning, and Digital Boutique Advisor opportunities
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🌍 Designed for future digital-first generations
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🎯 Process orientation and practical ecosystem thinking
                  </p>
                </div>
                
                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    ⚡ AI-assisted transformation ecosystem
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    📈 Continuous learning and skill progression
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🧠 Behavioral improvement and Kaizen growth journeys
                  </p>
                </div>

              </div>
            </div>

          </div>
        )}

        {activeTab === "genalpha" && (
          <div className="space-y-4">

            <div className="rounded-2xl bg-slate-900 border border-pink-500/20 p-3 lg:p-5 shadow-xl">
              <h2 className="text-sm lg:text-xl font-bold text-pink-300 flex items-center gap-2">
                <i className="fa-solid fa-wand-magic-sparkles"></i>
                What is the Gen Alpha Era?
              </h2>

              <div className="space-y-3 mt-3">
                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  🌍 Gen Alpha is the first fully AI-native generation growing up in a world of intelligent systems, immersive digital ecosystems, automation, smart devices, and hyper-personalized experiences.
                </p>

                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  ⚡ Unlike Gen Z that adapted to AI later, Gen Alpha will grow with AI as a natural everyday companion for learning, creativity, communication, productivity, and decision-making.
                </p>

                <p className="text-xs lg:text-sm text-gray-300 leading-relaxed">
                  🚀 The Gen Alpha era is expected to redefine education, work, startups, creator economies, and digital ecosystems at massive scale.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">

              <div className="rounded-2xl bg-slate-900 border border-cyan-500/20 p-3 lg:p-5">
                <h3 className="text-sm lg:text-lg font-bold text-cyan-300 flex items-center gap-2">
                  <i className="fa-solid fa-robot"></i>
                  Gen Alpha Mindset
                </h3>

                <div className="space-y-3 mt-3">
                  <p className="text-xs lg:text-sm text-gray-300">
                    🤖 AI interaction, immersive learning, gamification, and adaptive ecosystems will feel completely natural to Gen Alpha.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    🎮 Learning experiences will become more interactive, visual, simulation-driven, and ecosystem-based.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    📈 Skills, adaptability, creativity, ecosystem participation, and digital confidence will matter more than static memorization.
                  </p>
                </div>
              </div>

              <div className="rounded-2xl bg-slate-900 border border-purple-500/20 p-3 lg:p-5">
                <h3 className="text-sm lg:text-lg font-bold text-purple-300 flex items-center gap-2">
                  <i className="fa-solid fa-globe"></i>
                  Future Ecosystem Era
                </h3>

                <div className="space-y-3 mt-3">
                  <p className="text-xs lg:text-sm text-gray-300">
                    🌐 Gen Alpha will operate inside highly connected ecosystems combining AI, digital identity, learning, startups, automation, and decentralized collaboration.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    🚀 The future will reward creators, operators, innovators, ecosystem thinkers, and transformation leaders.
                  </p>

                  <p className="text-xs lg:text-sm text-gray-300">
                    ⚡ Continuous adaptation and learning agility will become core survival skills.
                  </p>
                </div>
              </div>

            </div>

            <div className="rounded-2xl bg-gradient-to-r from-pink-900/40 to-purple-900/40 border border-pink-400/20 p-3 lg:p-5">
              <h3 className="text-sm lg:text-lg font-bold text-pink-200 flex items-center gap-2">
                <i className="fa-solid fa-lightbulb"></i>
                Why Think5Whys Fits the Gen Alpha Future
              </h3>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-4">

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🤖 AI-first ecosystem thinking
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🎮 Gamified continuous learning journeys
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🌍 Digital transformation and ecosystem participation
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    📈 Smart certifications and practical capability development
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    🚀 Startup, creator, and earning opportunities
                  </p>
                </div>

                <div className="rounded-xl bg-black/30 p-3 border border-white/10">
                  <p className="text-xs lg:text-sm text-gray-200">
                    ⚡ Built for future AI-native generations
                  </p>
                </div>

              </div>
            </div>

          </div>
        )}

        {/* 🚀 GEN Z DIGITAL STARTUP - FULL 5W1H + RCA FRAMEWORK */}
        {activeTab === "startup" && (
          <div className="space-y-4">

            <h2 className="text-sm lg:text-xl font-bold text-pink-300 flex items-center gap-2">
              🚀 Gen Z Digital Startup
            </h2>

            {/* ⚡ ONE LINE PROBLEM */}
            <div className="mt-3">
              <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                ⚡ Gen Z has unlimited digital tools and AI access, but lacks structured systems to convert knowledge into real skills, startups, and sustainable earning opportunities.
              </p>
            </div>

            {/* 🧠 DEEP INSIGHT */}
            <div className="mt-4">
              <h3 className="text-xs lg:text-sm font-bold text-cyan-300 flex items-center gap-2">
                <i className="fa-solid fa-brain"></i> Deep Insight on Problem / Opportunity
              </h3>

              <div className="space-y-2 mt-2">
                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  Modern Gen Z is highly connected but not systematically trained.
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Key gap is execution structure — not access.</b>
                </p>

                <ul className="list-disc ml-5 text-xs lg:text-sm text-gray-300 [&_li]:text-gray-300 space-y-1">
                  <li>Information is abundant, but transformation is missing</li>
                  <li>AI is used for answers, not capability building</li>
                  <li>Learning is fragmented, not system-driven</li>
                  <li>Startup ideas exist, but execution discipline is weak</li>
                  <li>Education systems are not aligned with AI + creator economy era</li>
                </ul>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  👉 Result: High potential, low structured output
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  Knowledge → Skill → System → Startup → Earning
                </p>
              </div>
            </div>

            {/* 🔍 5 WHYS */}
            <div className="mt-5">
              <h3 className="text-xs lg:text-sm font-bold text-yellow-300 flex items-center gap-2">
                <i className="fa-solid fa-question"></i> 5 Whys Analysis
              </h3>

              <div className="space-y-3 mt-2">

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Why 1:</b> Why do Gen Z learners struggle despite AI and internet?<br />
                  → Because access is not structured into learning systems.
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Why 2:</b> Why is learning not structured?<br />
                  → Because content is fragmented and not outcome-driven.
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Why 3:</b> Why is it not outcome-driven?<br />
                  → Because traditional education focuses on theory, not execution.
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Why 4:</b> Why do startup attempts fail?<br />
                  → Because there is no guided ecosystem for real-world execution.
                </p>

                <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                  <b>Why 5:</b> Why is this a long-term issue?<br />
                  → Because AI-era skills require continuous, system-based learning — not static education.
                </p>

              </div>
            </div>

            {/* 🧠 ROOT CAUSE */}
            <div className="mt-5 p-3 rounded-xl bg-slate-900 border border-red-500/20">
              <h3 className="text-xs lg:text-sm font-bold text-red-300 flex items-center gap-2">
                <i className="fa-solid fa-triangle-exclamation"></i> Root Cause
              </h3>

              <p className={"rounded-xl bg-black/30 p-3 border border-white/10"}>
                No structured bridge exists between knowledge, execution, and earning in a unified ecosystem.
              </p>
            </div>

            {/* 🚀 SOLUTION */}
            <div className="mt-5">
              <h3 className="text-xs lg:text-sm font-bold text-green-300 flex items-center gap-2">
                <i className="fa-solid fa-rocket"></i> Solution Direction
              </h3>

              <ul className="list-disc ml-5 text-xs lg:text-sm text-gray-300 [&_li]:text-gray-300 space-y-1 mt-2">
                <li>Turn learning into action</li>
                <li>Make AI a productivity tool, not dependency</li>
                <li>Enable startup thinking early</li>
                <li>Build collaborative execution groups</li>
                <li>Link skills directly to earning opportunities</li>
              </ul>
            </div>

            {/* ⚡ QUICK ACTIONS */}
            <div className="mt-5">
              <h3 className="text-xs lg:text-sm font-bold text-orange-300 flex items-center gap-2">
                <i className="fa-solid fa-bolt"></i> Quick Actions (Gen Z Ready)
              </h3>

              <ul className="list-disc ml-5 text-xs lg:text-sm text-gray-300 [&_li]:text-gray-300 space-y-1 mt-2">
                <li>Learn by building, not just watching</li>
                <li>Join small execution groups (2–5 people)</li>
                <li>Use AI for productivity + projects</li>
                <li>Start micro-digital services locally</li>
                <li>Track learning → execution → output</li>
              </ul>
            </div>

             {/* 5W1H GRID */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-4">

                {/* WHAT */}
                <div className="p-3 rounded-xl bg-slate-900 border border-cyan-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-cyan-300 flex items-center gap-2">
                    <i className="fa-solid fa-box"></i> What
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    Transformation-as-a-Platform converting learners into creators, operators, and startup builders through structured ecosystem learning.
                  </p>
                </div>

                {/* WHY */}
                <div className="p-3 rounded-xl bg-slate-900 border border-yellow-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-yellow-300 flex items-center gap-2">
                    <i className="fa-solid fa-question"></i> Why
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    Traditional education fails to connect knowledge with execution, AI-era skills, and real earning opportunities.
                  </p>
                </div>

                {/* WHO */}
                <div className="p-3 rounded-xl bg-slate-900 border border-emerald-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-emerald-300 flex items-center gap-2">
                    <i className="fa-solid fa-users"></i> Who
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    Gen Z, Gen Alpha learners, early founders, creators, and small collaborative startup teams (2–5 members).
                  </p>
                </div>

                {/* WHERE */}
                <div className="p-3 rounded-xl bg-slate-900 border border-purple-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-purple-300 flex items-center gap-2">
                    <i className="fa-solid fa-location-dot"></i> Where
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    Digital-first ecosystem platform combining mobile learning, AI tools, local startup groups, and global execution networks.
                  </p>
                </div>

                {/* WHEN */}
                <div className="p-3 rounded-xl bg-slate-900 border border-pink-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-pink-300 flex items-center gap-2">
                    <i className="fa-solid fa-clock"></i> When
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    During education, skill-building, career formation, and early startup exploration phases.
                  </p>
                </div>

                {/* HOW */}
                <div className="p-3 rounded-xl bg-slate-900 border border-orange-500/20">
                  <h3 className="text-xs lg:text-sm font-bold text-orange-300 flex items-center gap-2">
                    <i className="fa-solid fa-gears"></i> How
                  </h3>
                  <p className="text-xs lg:text-sm text-gray-300 mt-2">
                    Through BOK learning system, FuelStash motivation layer, execution tasks, Digital Boutique Advisor startups, and continuous transformation tracking.
                  </p>
                </div>

              </div>

              {/* THINK5WHYS INSIGHT */}
              <div className="mt-4 p-3 rounded-xl bg-gradient-to-r from-cyan-900/30 to-blue-900/30 border border-cyan-400/20">
                <h3 className="text-xs lg:text-sm font-bold text-cyan-200 flex items-center gap-2">
                  <i className="fa-solid fa-brain"></i> Core Insight
                </h3>
                <p className="text-xs lg:text-sm text-gray-300 mt-2">
                  Think5Whys is not just a learning platform — it is a transformation engine converting knowledge into execution, startups, and earning ecosystems.
                </p>
              </div>

            {/* 🌍 ECOSYSTEM ROLE */}
            <div className="mt-5 p-3 rounded-xl bg-gradient-to-r from-cyan-900/30 to-blue-900/30 border border-cyan-400/20">
              <h3 className="text-xs lg:text-sm font-bold text-cyan-200 flex items-center gap-2">
                <i className="fa-solid fa-globe"></i> Think5Whys Ecosystem Role
              </h3>

              <ul className="list-disc ml-5 text-xs lg:text-sm text-gray-300 space-y-1 [&_li]:text-gray-300 mt-2">
                <li>Structuring learning into execution paths</li>
                <li>Enabling Digital Boutique Advisor startups</li>
                <li>Connecting skills with earning ecosystems</li>
                <li>Building AI-assisted transformation journeys</li>
                <li>Turning learners into operators & creators</li>
              </ul>
            </div>

            {/* 🌍 ECOSYSTEM NAVIGATION GRID - CTA*/}
            <div className="mt-6">
              <h3 className="text-xs lg:text-sm font-bold text-cyan-300 mb-3 flex items-center gap-2">
                <i className="fa-solid fa-layer-group"></i>
                Explore Think5Whys Ecosystem
              </h3>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                {eightPillars.map((item) => (
                  <button
                    key={item.label}
                    onClick={() => navigate(item.path)}
                    className="group rounded-xl bg-slate-900 border border-slate-700 hover:border-cyan-400 p-3 text-left transition-all"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-lg">{item.icon}</span>
                      <span className="text-xs lg:text-sm font-semibold text-gray-200 group-hover:text-cyan-300">
                        {item.label}
                      </span>
                    </div>
                    <p className="text-[10px] lg:text-xs text-gray-400 mt-2 line-clamp-2">
                      {item.desc}
                    </p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
